import { css } from '@emotion/react';
import { useTranslation } from '@frontend/i18n';
import { theme } from '@frontend/theme';
import { Button } from '@frontend/design-system';

export const ButtonBar = ({
  primaryButtonLabel,
  primaryButtonDisabled,
  backButtonLabel,
  omitBackButtonIcon,
  trackingIdPrefix,
  onPrimaryButtonClick,
  onCancelClick,
  onBackClick,
}: {
  primaryButtonLabel: string;
  primaryButtonDisabled?: boolean;
  backButtonLabel?: string;
  omitBackButtonIcon?: boolean;
  trackingIdPrefix?: string;
  onPrimaryButtonClick: () => void;
  onCancelClick: () => void;
  onBackClick?: () => void;
}) => {
  const { t } = useTranslation('phone');

  return (
    <div
      css={css`
        display: flex;
        justify-content: ${onBackClick ? 'space-between' : 'flex-end'};
        margin-top: auto;
        padding: 16px 32px 32px 32px;
      `}
    >
      {onBackClick && (
        <Button
          size='large'
          iconName={omitBackButtonIcon ? undefined : 'back'}
          variant='tertiary'
          onClick={onBackClick}
          data-trackingid={trackingIdPrefix ? `${trackingIdPrefix}-back-button` : undefined}
        >
          {!!backButtonLabel ? backButtonLabel : t('Back')}
        </Button>
      )}
      <div
        css={css`
          display: flex;
          gap: ${theme.spacing(2)};
        `}
      >
        <Button
          size='large'
          variant='secondary'
          onClick={onCancelClick}
          data-trackingid={trackingIdPrefix ? `${trackingIdPrefix}-cancel-button` : undefined}
        >
          {t('Cancel')}
        </Button>
        <Button
          size='large'
          disabled={primaryButtonDisabled}
          variant='primary'
          onClick={onPrimaryButtonClick}
          data-trackingid={trackingIdPrefix ? `${trackingIdPrefix}-primary-button` : undefined}
        >
          {primaryButtonLabel}
        </Button>
      </div>
    </div>
  );
};
